import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../../components/bootstrap/Modal';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Checks, { ChecksGroup } from '../../../../components/bootstrap/forms/Checks';
import Input from '../../../../components/bootstrap/forms/Input';
import Button from '../../../../components/bootstrap/Button';
import { useFormik } from 'formik';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../../components/bootstrap/Card';
import Select from '../../../../components/bootstrap/forms/Select';
import Label from '../../../../components/bootstrap/forms/Label';
import Option from '../../../../components/bootstrap/Option';
import moment from 'moment';
import AuthContext from '../../../../contexts/authContext';
import StatusPopup from '../../../../components/PlanningCalendar/StatusPopup';
import ErrorPopup from '../../../../components/extras/ErrorPopup';
import Spinner from '../../../../components/bootstrap/Spinner';
import Icon from '../../../../components/icon/Icon';
import Badge from '../../../../components/bootstrap/Badge';
import DisplayImage from '../../../../components/Activity/DisplayImage';
import Attachements from '../../../../components/Attachements/Attachements';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import useDarkMode from '../../../../hooks/useDarkMode';
import { DropdownItem, DropdownMenu } from '../../../../components/bootstrap/Dropdown';
import COLORS from '../../../../common/data/enumColors';
import {
	comptabiliserPaiementAPI,
	createAPI,
	paiementAPI,
	searchPythonAPI,
	uploadAttachmentAPI,
} from '../../../../apis/backend/apiPython';
import { date } from 'yup';
import ImageVisualisation from 'components/ImageVisualisation';
export const journals = ['espèces', 'carte_bancaire', 'chèque', 'virement'];
export const sortes = ['Acompte', 'Reste', 'Total'];

export default function PopupPaiement({ setIsOpen, id, card, setCard, handeGet }) {
	const { userData } = useContext(AuthContext);
	const navigate = useNavigate();
	const [paymentType, setPaymentType] = useState('total');
	const [selectedImage, setSelectedImage] = useState(null); // Tracks the image for the popup
	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [obligation, setObligation] = useState(false);
	const [montantApayer, setMontantApayer] = useState();
	const [data, setData] = useState();
	const [searchItem, setSearchItem] = useState('');
	const [factures, setFactures] = useState([]);
	const [openList, setOpenList] = useState(false);
	const [facture, setFacture] = useState();
	const [invoiceData, setInvoiceData] = useState([]);
	const [installment, setInstallment] = useState([]);
	const [popupImage, setPopupImage] = useState(false);
	const fileInputRef = useRef(null);
	const minAmount = 0;
	const [attachments, setAttachments] = useState([]);



	const handleFileChange = (e) => {
		const files = Array.from(e.target.files);
		setAttachments(prev => [...prev, ...files]);
	};

	const removeAttachment = (index) => {
		setAttachments(prev => prev.filter((_, i) => i !== index));
	};

	const handelCreatePayment = async () => {
		setIsLoading(true);

		if (!invoiceData) {
			setObligation('Veuillez sélectionner au moins une facture SVP');
			setIsLoading(false);
			return;
		}

		try {

			const paymentMoves = [invoiceData?.id];
			const globalPaymentData = {
				payment_type: 'inbound',
				partner_type: 'customer',
				payment_method: formik?.values?.payment_method,
				partner_id: invoiceData?.partner_id,
				partner_name: invoiceData?.partner_name,
				company_id: invoiceData?.company_id,
				currency: invoiceData?.currency,
				amount: installment.amount,
				rest_amount: installment.amount,
				date: moment(installment.date).format('YYYY-MM-DD'),
				date_payment: moment(installment.date_payment).format('YYYY-MM-DD'),
				state: 'draft',
				payment_moves: paymentMoves, // Include payment moves in the same request
			};

			const res = await paiementAPI(globalPaymentData);
			const moduleName = 'paiements';

			// File upload functionality (unchanged)
			if (attachments?.length > 0 && res?.id) {
				console.log("attachments", res)
				try {
					const formData = new FormData();
					attachments.forEach((file) => {
						formData.append('files', file);
					});
					formData.append('module', moduleName);
					formData.append('record_id', res?.id);

					await uploadAttachmentAPI(formData);
				} catch (uploadError) {
					console.error(`Échec de l'upload du fichier:`, uploadError);
					setError(`Échec de l'upload des fichiers.`);
				}

			}
			setSuccess(`Paiement global enregistré avec succès`);
			handeGet(id);
			setIsOpen(false);



			setSuccess(`Paiement(s) enregistré(s) avec succès)`);
			setIsOpen(false);
		} catch (error) {
			console.error('Erreur lors de la création des paiements :', error);
			setObligation("Une erreur est survenue lors de l'enregistrement du paiement");
		} finally {
			setIsLoading(false);
		}
	};



	const formik = useFormik({
		initialValues: {
			paiement: 'total',
			amount: card?.amount || montantApayer,
			payment_method: card?.payment_method || journals[0],
			sorte: card?.sorte || sortes[0],
			move_ids: card?.move_ids,
			activity_user_id: userData?.id,
			payment_reference: '',
			date_payment: card?.date_payment || moment(Date.now()).format('YYYY-MM-DD'),
			company_id: userData?.company?.id,
			partner_id: card?.partner_id || '',
			partner_name: card?.partner_name || '',
			state: 'draft',
		},
		onSubmit: handelCreatePayment,
	});

	const calculateTotalAmount = () => {
		const totalAmount = parseFloat(invoiceData?.amount_total - invoiceData?.amount_payed);

		return parseFloat(totalAmount.toFixed(3));
	};

	const handelBlurAmount = (e) => {
		const enteredValue = parseFloat(e.target.value);
		const clampedValue = Math.max(minAmount, Math.min(enteredValue, montantApayer || 0));
		formik.setFieldValue('amount', clampedValue);
	};

	useEffect(() => {
		const totalAmount = calculateTotalAmount();
		if (montantApayer !== totalAmount) {
			setMontantApayer(totalAmount);
			setInstallment({
				date: moment().format('YYYY-MM-DD'),
				date_payment: moment().format('YYYY-MM-DD'),
				amount: parseFloat(totalAmount),
				reference: '',
				state: 'draft',
			});
			formik.setFieldValue('amount', totalAmount);
		}
	}, [invoiceData, card]);

	const searchFactureById = async () => {
		const filters = {
			and_conditions: [{ field: 'id', operator: '=', value: id }],
		};
		const result = await searchPythonAPI('factures', filters, 1, 0);
		setInvoiceData(result?.data?.[0]);
	};

	const handleInstallmentChange = (field, value) => {
		setInstallment((prev) => {
			const total = parseFloat(montantApayer || 0);
			let updated = { ...prev };

			if (field === 'amount') {
				const newValue = parseFloat(value || 0);

				if (newValue > total) {
					updated.amount = total;
					console.log('updated.amount (max):', total);
				} else {
					updated.amount = newValue;
					console.log('updated.amount (normal):', newValue);
				}
			} else {
				updated[field] = value;
			}

			return updated;
		});
	};

	useEffect(() => {
		searchFactureById();
	}, []);

	return (
		<Modal
			setIsOpen={() => { }}
			isOpen={true}
			isStaticBackdrop
			isScrollable
			size=''
		>
			<ModalHeader
				setIsOpen={() => {
					setIsOpen(false);
					setCard({});
				}}>Paiement</ModalHeader>
			<ModalBody>
				<ModalBody>
					<div className='row align-items-end mb-3'>
						<FormGroup className='col-md-12' label="Date d'encaissement">
							<Input
								type='date'
								value={installment?.date_payment}
								onChange={(e) =>
									handleInstallmentChange('date_payment', e.target.value)
								}
							/>
						</FormGroup>

						<FormGroup className='col-md-12' label='Montant'>
							<Input
								type='number'
								value={installment?.amount}
								onChange={(e) =>
									handleInstallmentChange('amount', e.target.value)
								}
							/>
						</FormGroup>


						<FormGroup className='col-md-12'>
							<Label>Moyen de paiement *</Label>
							<Select
								ariaLabel='ariaLabel'
								placeholder={'-- aucun --'}
								onChange={(e) => {
									const selectedValue = e.target.value;
									formik.setFieldValue('payment_method', selectedValue);
								}}
								name='payment_method'>
								{journals?.map((journal, idx) => {
									return (
										<Option
											key={idx}
											type='radio'
											name={'payment_method'}
											id={journal}
											value={journal} // Sérialise id et name
											checked={
												journal == formik?.values?.payment_method
											}>
											{journal.replace(/_/g, ' ')}
										</Option>
									);
								})}
							</Select>
						</FormGroup>
						<FormGroup className='col-md-12'>
							<Label>Type *</Label>
							<Select
								ariaLabel='ariaLabel'
								placeholder={'-- aucun --'}
								onChange={(e) => {
									const selectedValue = e.target.value;
									formik.setFieldValue('payment_method', selectedValue);
								}}
								name='payment_method'>
								{sortes?.map((sorte, idx) => {
									return (
										<Option
											key={idx}
											type='radio'
											name={'sorte'}
											id={sorte}
											value={sorte} // Sérialise id et name
											checked={
												sorte == formik?.values?.sorte
											}>
											{sorte.replace(/_/g, ' ')}
										</Option>
									);
								})}
							</Select>
						</FormGroup>
						<FormGroup className='col-md-12 mt-4' label="Justificatifs (Pièces Jointes)">
							{/* --- Upload Zone --- */}
							<div className="border border-dashed p-3 text-center rounded">
								<input
									type="file"
									ref={fileInputRef}
									className="d-none"
									multiple
									onChange={handleFileChange}
									accept="image/*" // Optional: limits selection to images
								/>
								<Button
									color="info"
									isLight
									icon="CloudUpload"
									onClick={() => fileInputRef.current.click()}
								>
									Choisir des fichiers
								</Button>
							</div>

							{/* --- Preview Zone (Separated) --- */}
							<div className="mt-3 d-flex flex-wrap gap-3">
								{attachments.map((file, i) => {
									const imageUrl = URL.createObjectURL(file);
									return (
										<div key={i} className="position-relative border rounded p-1" style={{ width: '200px' }}>
											<img
												src={imageUrl}
												alt={file.name}
												className="img-fluid rounded cursor-pointer"
												style={{ height: '150px', width: '100%', objectFit: 'cover' }}
												onClick={() => setSelectedImage(imageUrl)} // <--- Open Popup
											/>

											<div
												className="position-absolute top-0 end-0 bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
												style={{ width: '20px', height: '20px', cursor: 'pointer', marginTop: '-5px', marginRight: '-5px', zIndex: 10 }}
												onClick={() => removeAttachment(i)}
											>
												<Icon icon="Close" size="xs" />
											</div>
										</div>
									);
								})}
							</div>
						</FormGroup>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button
						color='primary'
						className='w-auto'
						icon={'Save'}
						type='submit'
						isDisable={!formik.values.amount || isLoading}
						onClick={() => {
							handelCreatePayment();
						}}>
						Enregistrer
					</Button>
				</ModalFooter>
				{!!selectedImage && (
					<ImageVisualisation selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
				)}

				{!!error && <ErrorPopup error={error} setOpen={setError} />}
				{!!success && (
					<StatusPopup
						icon='Verified'
						color='success'
						title={'Super!'}
						label={success}
						setOpen={() => {
							setSuccess(false);
						}}
					/>
				)}

				{!!obligation && (
					<StatusPopup
						icon='info'
						color='info'
						title={obligation}
						// label={obligation}
						setOpen={setObligation}
					/>
				)}
			</ModalBody>
		</Modal>
	);
}
